// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Mw-YK","wrapper":"Header_wrapper__368ML","container":"Header_container__hOeBk","logo":"Header_logo__Ln+XZ"};